// extracted by mini-css-extract-plugin
export default {"menu__hamburger":"hamburger_menu__hamburger__CwxFy","menu__icon":"hamburger_menu__icon__vcH-b"};